import { render, staticRenderFns } from "./Bureau.vue?vue&type=template&id=2c6503f2"
import script from "./Bureau.vue?vue&type=script&lang=ts"
export * from "./Bureau.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports